// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__P_xYL","content":"style_content__Wt8f-"};